export default __webpack_public_path__ + "static/media/resting.a334652e.svg";